import { render, staticRenderFns } from "./ContactPopupTags.vue?vue&type=template&id=9440bd7e&"
import script from "./ContactPopupTags.vue?vue&type=script&lang=js&"
export * from "./ContactPopupTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports